module.exports = __webpack_public_path__ + "static/media/exclamation-octagon.7a069ef8.svg";